import { useCommonItems } from "../../../../../../contexts/CommonItensProvider";
import { useAppContext } from "../../../../../../contexts/AppContext";
import { useEffect, useState } from "react";
import { carregaPontosEntrega } from "../../configs/functions";
import { getDefaultValueSelectField } from "../../../../../../utils";
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Divider, Grid, InputAdornment, MenuItem, TextField, Typography
} from "@mui/material";
import { getFormErrorMessage } from "../../../../../../configs/functions";
import { TooltipSelectDisabled } from "../../../../../common/TooltipSelectDisabled";
import { Controller } from "react-hook-form";
import { grey } from "@mui/material/colors";
import LanIcon from "@mui/icons-material/Lan";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import FourGMobiledataIcon from "@mui/icons-material/FourGMobiledata";

export function FirstStepLockerForm({
                                        values,
                                        armario,
                                        empresas,
                                        register,
                                        errors,
                                        clearErrors,
                                        control,
                                        setValue,
                                        setQtdLinhas,
                                        setQtdColunas,
                                        setQtdPortas,
                                        onResetPortas,
                                        portas,
                                        qtdLinhas,
                                        qtdColunas,
                                    }) {
    const { exibirDialog, handleCloseDialog, exibirAlerta } = useCommonItems();
    const { dadosUsuario } = useAppContext();

    const [pontosEntrega, setPontosEntrega] = useState([]);
    const [selectedEmpresaId, setSelectedEmpresaId] = useState();

    const linhasLocal  = qtdLinhas  ?? armario?.numero_linhas  ?? 1;
    const colunasLocal = qtdColunas ?? armario?.numero_colunas ?? 1;

    const [confirmDialog, setConfirmDialog] = useState({ open: false, tipo: null, novoValor: null });

    const equipmentContractTypes = [
        { value: 'locacao', text: 'Locação' },
        { value: 'venda',   text: 'Venda'   },
    ];

    const portasConfiguradas = portas?.some(p =>
        p.status !== 'livre' || p.groupId !== null || p.id_produto !== null
    ) ?? false;

    const loadPontosEntrega = async (empresaId) => {
        try {
            const response = await carregaPontosEntrega({ id_empresa: empresaId });
            const lista = response.data.data;

            setPontosEntrega(lista);

            const defaultValuePontoEntrega =
                values.id_ponto_entrega ||
                getDefaultValueSelectField(armario, armario?.pontoEntrega?.id, lista);

            setValue('id_ponto_entrega', defaultValuePontoEntrega, { shouldDirty: true });
        } catch (error) {
            exibirAlerta('Erro ao carregar os Pontos de Entrega', '', 'error');
        }
    };

    useEffect(() => {
        if (values.id_empresa) setSelectedEmpresaId(values.id_empresa);
        return () => setSelectedEmpresaId(null);
    }, [values.id_empresa]);

    useEffect(() => {
        if (selectedEmpresaId) {
            exibirDialog('Carregando dados da Empresa...');
            loadPontosEntrega(selectedEmpresaId).finally(handleCloseDialog);
        }
    }, [selectedEmpresaId]);

    const aplicarMudancaDimensao = (tipo, valor) => {
        const novasLinhas  = tipo === 'linhas'  ? valor : linhasLocal;
        const novasColunas = tipo === 'colunas' ? valor : colunasLocal;

        if (tipo === 'linhas') {
            setValue('numero_linhas', valor, { shouldDirty: true });
            setQtdLinhas?.(valor);
        } else {
            setValue('numero_colunas', valor, { shouldDirty: true });
            setQtdColunas?.(valor);
        }

        setQtdPortas?.(novasLinhas * novasColunas);
        onResetPortas?.(novasLinhas, novasColunas);
    };

    const handleLinhasChange = (e) => {
        const valor = Math.max(1, parseInt(e.target.value) || 1);
        if (portasConfiguradas) {
            setConfirmDialog({ open: true, tipo: 'linhas', novoValor: valor });
        } else {
            aplicarMudancaDimensao('linhas', valor);
        }
    };

    const handleColunasChange = (e) => {
        const valor = Math.max(1, parseInt(e.target.value) || 1);
        if (portasConfiguradas) {
            setConfirmDialog({ open: true, tipo: 'colunas', novoValor: valor });
        } else {
            aplicarMudancaDimensao('colunas', valor);
        }
    };

    const handleConfirmReset = () => {
        aplicarMudancaDimensao(confirmDialog.tipo, confirmDialog.novoValor);
        setConfirmDialog({ open: false, tipo: null, novoValor: null });
    };

    const handleCancelReset = () => {
        setValue(
            confirmDialog.tipo === 'linhas' ? 'numero_linhas' : 'numero_colunas',
            confirmDialog.tipo === 'linhas' ? linhasLocal : colunasLocal
        );
        setConfirmDialog({ open: false, tipo: null, novoValor: null });
    };

    return (
        <>
            <Dialog open={confirmDialog.open} onClose={handleCancelReset}>
                <DialogTitle>Atenção</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Alterar a quantidade de {confirmDialog.tipo === 'linhas' ? 'linhas' : 'colunas'} irá
                        apagar todos os agrupamentos e configurações de produtos já definidos nas portas.
                        Deseja continuar?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelReset} variant="outlined">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmReset} variant="contained" color="error">
                        Confirmar e resetar
                    </Button>
                </DialogActions>
            </Dialog>

            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        autoFocus
                        InputLabelProps={{ shrink: true }}
                        margin='dense'
                        label='Nome'
                        placeholder='Digite o nome do Armário'
                        name='nome'
                        fullWidth
                        {...register("nome", { required: true })}
                        error={!!errors.nome}
                        helperText={getFormErrorMessage(errors, 'nome')}
                        autoComplete='off'
                        disabled={!dadosUsuario.isSempher}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        margin='dense'
                        label='Código de Identificação'
                        placeholder='Digite o código de identificação'
                        name='tag_identificacao'
                        fullWidth
                        {...register("tag_identificacao")}
                        error={!!errors.tag_identificacao}
                        helperText={!!errors.tag_identificacao ? getFormErrorMessage(errors, 'tag_identificacao') : 'O código será criado automaticamente se não preenchido.'}
                        disabled={!dadosUsuario.isSempher}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        label="Quantidade de Linhas"
                        name='numero_linhas'
                        type="number"
                        fullWidth
                        inputProps={{ min: 1 }}
                        defaultValue={armario?.numeroLinhas ?? 1}
                        error={!!errors.numero_linhas}
                        helperText={getFormErrorMessage(errors, 'numero_linhas')}
                        {...register("numero_linhas", { required: true, min: 1 })}
                        sx={{ mt: 1 }}
                        onChange={handleLinhasChange}
                        disabled={!dadosUsuario.isSempher || armario?.numeroLinhas}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        label="Quantidade de Colunas"
                        name='numero_colunas'
                        type="number"
                        fullWidth
                        inputProps={{ min: 1 }}
                        defaultValue={armario?.numeroColunas ?? 1}
                        error={!!errors.numero_colunas}
                        helperText={getFormErrorMessage(errors, 'numero_colunas')}
                        {...register("numero_colunas", { required: true, min: 1 })}
                        sx={{ mt: 1 }}
                        onChange={handleColunasChange}
                        disabled={!dadosUsuario.isSempher || armario?.numeroColunas}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        label="Quantidade de Portas"
                        fullWidth
                        value={linhasLocal * colunasLocal}
                        sx={{ mt: 1 }}
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                        helperText="Calculado automaticamente (linhas × colunas)"
                        disabled
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        margin='dense'
                        label='Descrição'
                        placeholder='Digite a Descrição'
                        name='descricao'
                        fullWidth
                        {...register("descricao")}
                        multiline
                        rows={3}
                        error={!!errors.descricao}
                        helperText={getFormErrorMessage(errors, 'descricao')}
                        disabled={!dadosUsuario.isSempher}
                    />
                </Grid>

                {empresas && (
                    <>
                        <Grid item xs={12} md={4}>
                            <TooltipSelectDisabled
                                isDisabled={!(!!armario)}
                                text="Não é possível alterar a Empresa de um Armário já cadastrado"
                            >
                                <Controller
                                    name='id_empresa'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={armario ? armario.empresa.id : ''}
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <TextField
                                            {...field}
                                            select
                                            fullWidth
                                            sx={{ mt: 1 }}
                                            label="Empresa"
                                            disabled={!!armario}
                                            defaultValue={armario ? armario.empresa.id : ''}
                                            onChange={(e) => {
                                                setSelectedEmpresaId(e.target.value);
                                                setValue('id_empresa', e.target.value, { shouldDirty: true });
                                                setValue('id_ponto_entrega', '', { shouldDirty: true });
                                                if (e.target.value) clearErrors('id_empresa');
                                            }}
                                            error={!!errors.id_empresa}
                                            helperText={getFormErrorMessage(errors, 'id_empresa')}
                                        >
                                            {empresas.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.nomeFantasia}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                            </TooltipSelectDisabled>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TooltipSelectDisabled isDisabled={!selectedEmpresaId}>
                                <Controller
                                    name='id_ponto_entrega'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={armario?.pontoEntrega?.id ?? ''}
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <TextField
                                            {...field}
                                            select
                                            fullWidth
                                            sx={{ mt: 1 }}
                                            label="Ponto de Entrega"
                                            disabled={!dadosUsuario.isSempher || !selectedEmpresaId}
                                            onChange={(e) => {
                                                setValue('id_ponto_entrega', e.target.value, { shouldDirty: true });
                                                if (e.target.value) clearErrors('id_ponto_entrega');
                                            }}
                                            error={!!errors.id_ponto_entrega}
                                            helperText={getFormErrorMessage(errors, 'id_ponto_entrega')}
                                        >
                                            {pontosEntrega.length > 0 ? (
                                                [
                                                    ...pontosEntrega.filter(o => o.status !== 0).map(o => (
                                                        <MenuItem key={o.id} value={o.id}>{o.nome}</MenuItem>
                                                    )),
                                                    ...pontosEntrega.filter(o => o.status === 0).map(o => (
                                                        <MenuItem key={o.id} value={o.id} disabled>{o.nome} - (Inativo)</MenuItem>
                                                    )),
                                                ]
                                            ) : (
                                                <MenuItem disabled>
                                                    {selectedEmpresaId ? 'Nenhum disponível' : 'Selecione uma empresa primeiro'}
                                                </MenuItem>
                                            )}
                                        </TextField>
                                    )}
                                />
                            </TooltipSelectDisabled>
                        </Grid>
                    </>
                )}

                <Grid item xs={12} md={4}>
                    <Controller
                        name="tipo_contrato"
                        control={control}
                        defaultValue={armario ? armario.tipoContrato : 'locacao'}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <TextField
                                select
                                label="Tipo de Contrato"
                                fullWidth
                                disabled={!dadosUsuario.isSempher}
                                error={!!errors.tipo_contrato}
                                helperText={getFormErrorMessage(errors, 'tipo_contrato')}
                                sx={{ mt: 1 }}
                                {...field}
                            >
                                {equipmentContractTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.text}</MenuItem>
                                ))}
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Divider sx={{ mt: 3 }} textAlign="center">
                        <Typography variant="subtitle1" sx={{ color: grey[700] }}>
                            Dados de conexão
                        </Typography>
                    </Divider>
                </Grid>

                {armario && (
                    <>
                        <Grid item xs={12} md={4}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="IP Ethernet"
                                placeholder="Ex: 192.168.0.1"
                                name="ip_ethernet"
                                defaultValue={armario?.ip_ethernet ?? ''}
                                fullWidth
                                {...register("ip_ethernet")}
                                error={!!errors.ip_ethernet}
                                helperText={getFormErrorMessage(errors, "ip_ethernet")}
                                disabled
                                InputProps={{ endAdornment: <InputAdornment position="end"><LanIcon /></InputAdornment> }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="IP Wifi"
                                placeholder="Ex: 192.168.0.1"
                                name="ip_wifi"
                                defaultValue={armario?.ipWifi ?? ''}
                                fullWidth
                                {...register("ip_wifi")}
                                error={!!errors.ip_wifi}
                                helperText={getFormErrorMessage(errors, "ip_wifi")}
                                disabled
                                InputProps={{ endAdornment: <InputAdornment position="end"><RssFeedIcon /></InputAdornment> }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                margin="dense"
                                label="IP 4G"
                                placeholder="Ex: 10.0.0.1"
                                name="ip_4g"
                                defaultValue={armario?.ip4g ?? ''}
                                fullWidth
                                {...register("ip_4g")}
                                error={!!errors.ip_4g}
                                helperText={getFormErrorMessage(errors, "ip_4g")}
                                disabled
                                InputProps={{ endAdornment: <InputAdornment position="end"><FourGMobiledataIcon /></InputAdornment> }}
                            />
                        </Grid>
                    </>
                )}

                <Grid item xs={12} md={4}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        label="MAC Ethernet"
                        placeholder="Ex: AA:BB:CC:DD:EE:FF"
                        name="mac_ethernet"
                        defaultValue={armario?.macEthernet ?? ''}
                        fullWidth
                        {...register("mac_ethernet")}
                        error={!!errors.mac_ethernet}
                        helperText={getFormErrorMessage(errors, "mac_ethernet")}
                        disabled={!dadosUsuario.isSempher}
                        InputProps={{ endAdornment: <InputAdornment position="end"><LanIcon /></InputAdornment> }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        label="MAC Wifi"
                        placeholder="Ex: AA:BB:CC:DD:EE:FF"
                        name="mac_wifi"
                        defaultValue={armario?.macWifi ?? ''}
                        fullWidth
                        {...register("mac_wifi")}
                        error={!!errors.mac_wifi}
                        helperText={getFormErrorMessage(errors, "mac_wifi")}
                        disabled={!dadosUsuario.isSempher}
                        InputProps={{ endAdornment: <InputAdornment position="end"><RssFeedIcon /></InputAdornment> }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        margin="dense"
                        label="MAC 4G"
                        placeholder="Ex: AA:BB:CC:DD:EE:FF"
                        name="mac_4g"
                        defaultValue={armario?.mac4g ?? ''}
                        fullWidth
                        {...register("mac_4g")}
                        error={!!errors.mac_4g}
                        helperText={getFormErrorMessage(errors, "mac_4g")}
                        disabled={!dadosUsuario.isSempher}
                        InputProps={{ endAdornment: <InputAdornment position="end"><FourGMobiledataIcon /></InputAdornment> }}
                    />
                </Grid>
            </Grid>
        </>
    );
}